import $ from 'jquery'

$('.product-selection-block__tabs button').on('click', function () {
  const button = $(this)
  const block = button.closest('.vn-block')
  const type = button.attr('data-show')
  const parent = button.parent().parent()
  const allButtons = parent.find('.product-selection-block__tabs button')
  const firstButton = allButtons.eq(0)
  const secondButton = allButtons.eq(1)
  const link = parent.find('.product-selection-block__cta')
  const selectionUrl = link.attr('data-selection-url')
  const promotionUrl = link.attr('data-promotion-url')

  if (this === firstButton.get(0)) {
    firstButton.removeClass('drap-btn--white')
    firstButton.addClass('drap-btn--secondary')

    secondButton.removeClass('drap-btn--primary')
    secondButton.addClass('drap-btn--white')
    block.removeClass('bg-black')
    link.attr('href', selectionUrl)
  }

  if (this === secondButton.get(0)) {
    firstButton.removeClass('drap-btn--secondary')
    firstButton.addClass('drap-btn--white')

    secondButton.removeClass('drap-btn--white')
    secondButton.addClass('drap-btn--secondary')
    block.addClass('bg-black')
    link.attr('href', promotionUrl)
  }

  parent.find('.product-selection-block__selection-posts').hide()

  parent
    .find(`.product-selection-block__selection-posts[data-type=${type}]`)
    .show()
})
